<template>
    <div>
        <!-- <el-main> -->
        <div v-for="(item,index) in childData" :key="index" class="font_card">
            <div class="row_header  el-row">
                <div class="el-col el-col-24">
                    <div class="el-col el-col-4">扣除项目</div>
                    <div class="el-col el-col-4">仪器</div>
                    <div class="el-col el-col-4">划扣金额</div>
                    <div class="el-col el-col-4">划扣次数</div>
                    <div class="el-col el-col-4">划扣卡号</div>
                    <div class="el-col el-col-4">备注</div>
                </div>
            </div>
            <div class="el-row">
                <div class="pad_10  el-col el-col-24">
                    <div class="el-col el-col-24">
                        <!-- 1扣除项目 -->
                        <div class="el-col el-col-4">
                            <span>{{item.musProjectName}}</span>
                        </div>
                        <!-- 2仪器 -->
                        <div class="el-col el-col-4">
                            <el-select @input="testSX" v-model="item.instrumentNo" clearable filterable placeholder="请选择仪器">
                                <el-option v-for="(item) in item.instruments" :key="item.id" :label="item.instrumentName" :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <!-- 3划扣金额 -->
                        <div class="el-col el-col-4">
                            <!-- {{item.musAmt}} -->
                            <el-input @input="testSX" disabled clearable v-model="item.musAmt" placeholder="请输入当日划扣金额" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                        </div>
                        <!-- 4划扣次数 -->
                        <div class="el-col el-col-4">
                            <!-- <el-input @input="tabInput($event,index,item)" clearable v-model="item.musContent" placeholder="请输入划扣次数" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input> -->
                            <el-input-number @change="handleChange($event,index,item)" size="mini" v-model="item.musContent" :max="item.maxNum" :min="1"></el-input-number>
                        </div>
                        <!-- 5划扣卡号 -->
                        <div class=" el-col el-col-4 " :class="item.musClass">
                            <el-input @input="testSX" oninput="value=value.replace(/[^0-9.]/g, '')" clearable v-model="item.musCode" placeholder="请输入划扣卡号" @change="cardChange($event,index)" @blur="cardBlur($event,index)"></el-input>
                            <div class="cardNum" v-if="item.flag">划扣卡号不存在!</div>
                            <span style="display:none;">{{item.musCodeTrue}}</span>
                        </div>
                        <!-- 6备注 -->
                        <div class="el-col el-col-3">
                            <el-input @input="testSX" clearable v-model="item.remark" placeholder="请输入备注"></el-input>
                        </div>
                        <!-- el-col-offset-2 -->
                        <div class=" el-col el-col-1">
                            <button type="button" class="el-button el-button--danger el-button--mini is-circle" @click.prevent="editRemoveDomain(item, index)"><i class="el-icon-delete"></i></button>
                        </div>
                    </div>
                    <div class="el-col el-col-24" style="margin-top: 4px;">
                        <span>划扣补充：</span>
                        <el-input style="width:60%;margin-right:10px;" @input="testSX" v-model="item.musReplenish" placeholder="请输入划扣补充"></el-input>
                        <el-button @click="editList(index)" type="primary" size="mini"><i class="el-icon-plus"></i>添加耗材</el-button>
                    </div>
                    <div class="el-col el-col-24" style="margin-top: 4px;">
                        <div v-for="(list, idx) in item.materialList " :key="idx">
                            <div class="font_header  el-row">
                                <div class=" el-col-24">
                                    <div class="el-col el-col-5">耗材名称</div>
                                    <div class="el-col el-col-4">耗材规格</div>
                                    <div class="el-col el-col-5">厂家</div>
                                    <div class="el-col el-col-5">数量</div>
                                    <div class="el-col el-col-4">实际使用</div>
                                    <div class=" el-col el-col-1">
                                        <button type="button" class="el-button el-button--danger el-button--mini is-circle" @click.prevent="delList(list,idx,index)"><i class="el-icon-minus"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div class="el-row">
                                <div class="pad_10  el-col el-col-24">
                                    <div class="el-col el-col-24">
                                        <!-- 1耗材名称 -->
                                        <div class="el-col el-col-5">
                                            <el-select :filter-method="((val)=>{materMatch(val, index,idx)})" default-first-option ref="mater" @change="materChange($event,index,idx)" @focus="materFocus($event,index,idx)" @input="testSX" v-model="list.materialName" clearable filterable placeholder="请选择耗材名称">
                                                <el-option v-for="(a) in item.materList" :key="a.menuName" :label="a.menuName" :value="a.menuName"></el-option>
                                            </el-select>
                                        </div>
                                        <!-- 2耗材规格 -->
                                        <div class="el-col el-col-4">
                                            <el-select @input="testSX" v-model="list.materialSpec" clearable filterable placeholder="请选择耗材规格" @change="specChange($event,index,idx)">
                                                <el-option v-for="(item,index) in list.specOption" :key="index" :label="item.menuSpec" :value="item.menuSpec"></el-option>
                                            </el-select>
                                        </div>
                                        <!-- 3厂家 -->
                                        <div class="el-col el-col-5">
                                            <el-select @input="testSX" v-model="list.manufacturers" clearable filterable placeholder="请选择厂家" @change="manuChange($event,index,idx)">
                                                <el-option v-for="(item,index) in list.manuOption" :key="index" :label="item.manufacturers" :value="item.manufacturers"></el-option>
                                            </el-select>
                                        </div>
                                        <!-- 4数量 -->
                                        <div class="el-col el-col-5">
                                            <el-input @input="testSX" clearable v-model="list.number" placeholder="请输入数量" oninput="value=value.replace(/[^0-9.]/g, '')"></el-input>
                                        </div>
                                        <!-- 5实际使用 -->
                                        <div class="el-col el-col-5">
                                            <el-input @input="testSX" clearable v-model="list.actualUse" placeholder="请输入"></el-input>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="el-col el-col-24" style="margin-top: 4px;">
                        <div class="doc_header  el-row">
                            <div class=" el-col-24">
                                <div class="el-col el-col-6">医生</div>
                                <div class="el-col el-col-6">医助</div>
                                <div class="el-col el-col-5">护士</div>
                                <div class="el-col el-col-7">产品备注</div>
                            </div>
                        </div>
                        <div class="el-row">
                            <div class="pad_10  el-col el-col-24">
                                <div class="el-col el-col-24">
                                    <!-- 医生 -->
                                    <div class="el-col el-col-6">
                                        <el-select @change="doctorChange($event,index,'doctor')" @input="testSX" @focus="focus(1)" @keydown.enter.native="enterDoctor($event,1,index)" ref="doctor" default-first-option :filter-method="doctorMatch" v-model="item.doctorName" clearable placeholder="请选择医生" filterable remote>
                                            <el-option v-for="(item) in newList1" :key="item.identityName" :label="item.identityName" :value="item.identityName"></el-option>
                                        </el-select>
                                    </div>
                                    <!-- 医助 -->
                                    <div class="el-col el-col-6">
                                        <el-select @change="doctorChange($event,index,'aideName')" @input="testSX" @focus="focus(4)" @keydown.enter.native="enterDoctor($event,4,index)" ref="idName" default-first-option :filter-method="bbMatch" v-model="item.aideName" clearable placeholder="请选择医助" filterable remote>
                                            <el-option v-for="(item) in newList4" :key="item.identityName" :label="item.identityName" :value="item.identityName"></el-option>
                                        </el-select>
                                    </div>
                                    <!-- 护士 -->
                                    <div class="el-col el-col-5">
                                        <el-select @change="doctorChange($event,index,'nurse')" @input="testSX" @focus="focus(2)" @keydown.enter.native="enterDoctor($event,2,index)" ref="nurseName" default-first-option :filter-method="aaMatch" v-model="item.nurseName" clearable placeholder="请选择护士" filterable remote>
                                            <el-option v-for="(item) in newList2" :key="item.identityName" :label="item.identityName" :value="item.identityName"></el-option>
                                        </el-select>
                                    </div>
                                    <!-- 产品备注 -->
                                    <div class="el-col el-col-7">
                                        <el-input @input="testSX" v-model="item.projectRemark" placeholder="请输入产品备注"></el-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- </el-main> -->
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
    props: ['childData', 'refundData'],
    data() {
        return {
            newList1: [],
            newList2: [],
        }
    },
    computed: {
        ...mapState(['statusOptions', 'floorOptions', 'areaOptions']),
        ...mapGetters(['list1', 'list2', 'list4', 'productOptions', 'materiaOption', 'instructmentList']),
    },
    created() {
        this.newList1 = this.$store.state.list1
        this.newList2 = this.$store.state.list2
        this.newList4 = this.$store.state.list4
        this.newData = this.$store.getters.productOptions;
    },
    methods: {
        tabInput(val, index, row) {
            row.musAmt = ''
            // console.log(val);
            if (val && val == 0) {
                row.musContent = 1
            } else if (val != 0) {
                row.musContent = Number(val)
                this.getVal(this.refundData, this.childData, row)
            }
        },
        handleChange(val, index, row) {
            row.maxNum = 2000
            this.getVal(this.refundData, this.childData, row, val)
            this.$forceUpdate()
        },
        getVal(refundData, childData, row, val) {
            row.musAmt = ''
            let newRefundData = refundData.map(v => {
                return { ...v, musContent: v.refundContent, musAmt: v.refundAmt }
            })
            let newList = newRefundData.concat(childData);
            // 筛选出当前划扣和退款的数据中存在几条当前项目
            let res2 = newList.filter(ele => ele.projectId === row.projectId)
            let res = res2.reduce((sumData, key, index, arrData) => {
                return sumData + key.musContent
            }, 0)
            let res3 = res2.reduce((sumData, key, index, arrData) => {
                return sumData + Number(key.musAmt)
            }, 0)
            if (Number(res) > Number(row.residueNumber)) {
                row.musAmt = (Number(row.projectAmt) - Number(row.amt) - res3).toFixed(2)
                row.maxNum = Number(row.residueNumber) - (res - val)
                _g.toast("warning", '有效次数不足！！！');
                return;
            } else if (Number(res) == Number(row.residueNumber)) {
                row.maxNum = Number(row.residueNumber) - (res - val)
                row.musAmt = (Number(row.projectAmt) - Number(row.amt) - res3).toFixed(2)
            } else if (Number(res) < Number(row.residueNumber)) {
                console.log('00000');
                row.musAmt = (row.unitPrice * row.musContent).toFixed(2)
            }

        },
        testSX() {
            this.$forceUpdate();
        },
        materMatch(val, index, idx) {
            this.childData[index].materList = _g.paramMatch(this.childData[index].consumables, this.childData[index].materList, val, 'menuName')
            this.$forceUpdate()
        },
        doctorMatch(val) {
            this.newList1 = _g.paramMatch(this.list1, this.newList1, val, 'identityName')
        },
        aaMatch(val) {
            this.newList2 = _g.paramMatch(this.list2, this.newList2, val, 'identityName')
        },
        bbMatch(val) {
            this.newList4 = _g.paramMatch(this.list4, this.newList4, val, 'identityName')
            console.log(this.newList4);
        },
        materFocus(val, index, idx) {
            this.childData[index].materList = this.childData[index].consumables
            this.$forceUpdate()
        },
        doctorChange(event, index, val) {
            if (val == 'doctor') {
                this.childData[index].aideName = '无'
            } else if (val == 'aideName') {
                this.childData[index].doctorName = '无'
                this.newList4.forEach(item => {
                    if (item.identityName == event) {
                        this.childData[index].doctorId = item.empNameNo
                    }
                });
                // console.log(this.childData[index]);
                // console.log(this.childData[index].doctorId);
                // console.log(this.childData[index].nurseId);
                if (this.childData[index].doctorId) {
                    if (this.childData[index].doctorId == this.childData[index].nurseId) {
                        _g.toast('warning', '医助和护士不能为同一人!!!')
                        this.childData[index].aideName = ''
                    }
                }
            } else if (val == 'nurse') {
                this.newList2.forEach(item => {
                    if (item.identityName == event) {
                        this.childData[index].nurseId = item.empNameNo
                    }
                });
                if (this.childData[index].doctorId) {
                    if (this.childData[index].doctorId == this.childData[index].nurseId) {
                        _g.toast('warning', '医助和护士不能为同一人!!!')
                        this.childData[index].nurseName = ''
                    }
                }
            }
        },
        materChange(val, index, idx) {
            this.childData[index].materialList[idx].price = ''
            this.childData[index].materialList[idx].materialSpec = ''
            this.childData[index].materialList[idx].manufacturers = '无'
            this.childData[index].materialList[idx].number = 1
            // console.log(this.childData[index].consumables);
            this.childData[index].consumables.forEach(ele => {
                if (val == ele.menuName) {
                    this.childData[index].materialList[idx].specOption = ele.menuSpecList
                    this.childData[index].materialList[idx].printProjectNo = ele.printProjectNo
                }
            });
            if (this.childData[index].materialList[idx].materialName == '') {
                this.childData[index].materialList[idx].specOption = []
                this.$forceUpdate()
            }
        },

        specChange(val, index, idx) {
            this.childData[index].materialList[idx].price = ''
            this.childData[index].materialList[idx].manufacturers = ''
            this.childData[index].materialList[idx].specOption.forEach(ele => {
                if (val == ele.menuSpec) {
                    this.childData[index].materialList[idx].manuOption = ele.manufacturersList
                }
            });
        },
        manuChange(val, index, idx) {
            this.childData[index].materialList[idx].manuOption.forEach(ele => {
                if (val == ele.manufacturers) {
                    this.childData[index].materialList[idx].materialId = ele.id
                    this.childData[index].materialList[idx].price = ele.price
                    this.childData[index].materialList[idx].accountingPrice = ele.accountingPrice
                }
            });
        },
        focus(val) {
            if (val == 1) {
                this.newList1 = this.list1
            } else if (val == 2) {
                this.newList2 = this.list2
            } else if (val == 4) {
                this.newList4 = this.list4
            }
        },
        // 新增耗材
        editList(index) {
            this.childData[index].materialList.push({
                key: Date.now(),
                materialId: '',
                materialName: '',
                materialSpec: '',
                price: '',
                number: '',
                actualUse: '',
            });
            this.$forceUpdate()
        },
        // 删除耗材
        delList(item, listIndex, nextIndex) {
            var index = this.childData[nextIndex].materialList.indexOf(item)
            if (index !== -1) {
                this.childData[nextIndex].materialList.splice(listIndex, 1)
            }
            this.$forceUpdate()
        },
        // 删除项目
        editRemoveDomain(item, listIndex) {
            let newRefundData = this.refundData.map(v => {
                return { ...v, musContent: v.refundContent, musAmt: v.refundAmt }
            })
            let newList = newRefundData.concat(this.childData);
            // 筛选出当前划扣和退款的数据中存在几条当前项目
            let res2 = newList.filter(ele => ele.projectId === item.projectId)
            res2.forEach(item => {
                item.maxNum = 2000
            });
            // console.log(res2);
            var index = this.childData.indexOf(item);
            if (index !== -1) {
                this.childData.splice(listIndex, 1)
            }
        },
        enterDoctor(e, val, index, idx) {
            if (val == 6) {//当日扣除项目
                if (this.newData[0] != undefined) {
                    this.childData[index].musProjectId = this.newData[0].id
                    this.childData[index].musProjectName = this.newData[0].project
                    this.$forceUpdate()
                    this.$refs.mus[0].blur()
                }
            } else if (val == 1) {//医生
                if (this.newList1[0] != undefined) {
                    this.childData[index].doctorName = this.newList1[0].identityName
                    this.$forceUpdate()
                    this.$refs.doctor[0].blur()
                }
            } else if (val == 4) {//医生=助理
                if (this.newList4[0] != undefined) {
                    this.childData[index].aideName = this.newList4[0].identityName
                    this.$forceUpdate()
                    this.$refs.idName[0].blur()
                }
            } else if (val == 2) {//护士
                if (this.newList2[0] != undefined) {
                    this.childData[index].nurseName = this.newList2[0].identityName
                    this.$forceUpdate()
                    this.$refs.nurseName[0].blur()
                }
            }
        },
        // 划扣卡号查询提示
        cardBlur(e, index) {
            // musCodeTrue：划扣卡号是否存在 0、存在  1、不存在
            if (this.childData[index].musCode && this.childData[index].musCode != '') {
                let data = {
                    cadCode: this.childData[index].musCode,
                    pageSize: 1
                }
                api.requestQuiet("/skn/getClientInformation", data, (res) => {
                    if (res.result == true) {
                        if (res.data.mapList.length == 0) {
                            this.childData[index].musCodeTrue = 1
                            this.childData[index].flag = true
                            this.childData[index].musClass = 'musCode'
                        } else {
                            this.childData[index].flag = false
                            this.childData[index].musClass = ''
                            this.childData[index].musCodeTrue = 0
                        }
                    } else {
                        this.childData[index].musCodeTrue = 1
                        this.childData[index].flag = true
                        this.childData[index].musClass = 'musCode'
                        this.$forceUpdate()
                    }
                }, (err) => {
                });
            }
        },
        cardChange(e, index) {
            if (e == '' || !e) {
                this.childData[index].flag = false
                this.childData[index].musClass = ''
            }
        },
    }
}
</script>
<style scoped>
.font_card {
  border: 1px solid #eee;
  margin-bottom: 6px;
  /* background: #e0e6f0; */
  border-radius: 10px;
}
.row_header {
  background-color: #c2e0f1;
  padding: 10px;
  border-radius: 10px;
}
.main_font {
  font-size: 13px !important;
  font-weight: 500;
  /* border: 1px solid blue; */
}
.el-row {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.font_header {
  background-color: #fff7f3;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
}
.doc_header {
  background-color: #dbf0b9;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
}
.pad_10 {
  padding: 4px;
  box-sizing: border-box;
  line-height: 35px;
}
.cardNum {
  color: #f56c6c;
  font-size: 12px;
}
.musCode >>> .el-input__inner {
  border-color: #f56c6c;
}
</style>


